import {FieldName} from '@mintdata/mint-kit/api/values/frames/Frame';

export class FieldRef
{
    constructor(public readonly isSimpleRef:boolean,
                public readonly fieldName:string,
                public readonly fieldPath:FieldName[])
    {
    }

    public toLiteral():string
    {
        if( this.isSimpleRef )
            return this.fieldName;
        else
            return this.fieldPath.join('.');
    }
}
